export default [
  {
    key: 'name',
    label: 'field.name',
    type: 'text',
  },
]
